import { useQuery } from '@tanstack/react-query';
import { api } from './api';

/** The signed-in user's alliance (shares the `['me']` cache with App). */
export function useCurrentAlliance() {
  const { data } = useQuery({
    queryKey: ['me'],
    queryFn: () => api.me().catch(() => null),
    staleTime: 5 * 60 * 1000,
  });
  return data?.alliance ?? null;
}

/** Short display label: tag, falling back to the full name. */
export function useAllianceLabel() {
  const a = useCurrentAlliance();
  return a ? a.tag || a.name : '';
}
